<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
import ActivityListEditor from "../../components/Business/ActivityListEditor.svelte";
  import CommentListEditor from "../../components/Business/CommentListEditor.svelte";
  import CompanyDropdown from "../../components/Business/CompanyDropdown.svelte";
  import ContactDropdown from "../../components/Business/ContactDropdown.svelte";
import MagazineSideEditor from "../../components/Business/MagazineSideEditor.svelte";
  import ProductDropdown from "../../components/Business/ProductDropdown.svelte";
import Secur8SideEditor from "../../components/Business/Secur8SideEditor.svelte";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
import DateInput from "../../components/Form/Fields/DateInput.svelte";
  // import UserTimeStats from "../../components/Business/UserTimeStats.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import SrlDropdown from "../../components/Form/Fields/Dropdown/SrlDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { ILead } from "../../entities";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
import { showToast } from "../../utils/misc/toast-utils";
  // import { formatCurrency } from "../../utils/date-utils";
  import {
    addActivity,
    activities,
    customFieldsSchemas,
    completeActivity,
    initDetail,
    record,
    save,
  } from "./lead.store";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit =
    $record != null &&
    $record.name != "" &&
    (isNew || $record.srlLeadStatusId != null);

    async function onSaveMagazine(ev: any)
  {
    $record.clfMagazineId = ev.detail;
    let _resp: IApiResponse<ILead> = await save();
    let u = _resp.payload;
    record.set(u);
    showToast("Operazione completata", 'is-success' );
  }

  async function onSaveSecur8(ev: any)
  {
    $record.clfSecur8Id = ev.detail;
    let _resp: IApiResponse<ILead> = await save();
    let u = _resp.payload;
    record.set(u);
    showToast("Operazione completata", 'is-success' );
  }

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<ILead> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/lead/${u.oid}`);
    } else {
      onCancel();
    }
  }
 
  async function onEditActivity(event)
  {

  }

  function onCancel() {
    navigate(`/lead`);
  }

  onMount(() => initDetail(oid));
</script>

<div>
  {#if $record}
    <div class="columns">
      <div class="column is-9">
        <FormLayout
          {canSubmit}
          {isNew}
          on:submit={onSubmit}
          on:cancel={onCancel}
        >
          <div class="columns">
            <div class="column is-8">
              <FormField>
                <Input
                  name="Nome"
                  placeholder="Nome"
                  required={true}
                  bind:value={$record.name}
                />
              </FormField>
            </div>

            {#if !isNew}
              <div class="column is-4">
                <FormField>
                  <SrlDropdown
                    name="Stato Lead"
                    schema="LEADSTATUS"
                    required={true}
                    clearVisible={false}
                    bind:value={$record.srlLeadStatusId}
                  />
                </FormField>
              </div>
            {/if}
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <CompanyDropdown
                  name="Organizzazione"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.companyId}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <ContactDropdown
                  name="Contatto"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.contactId}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <ClfDropdown
                  name="Sorgente"
                  schema="SOURCETYPS"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.clfSourceId}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <ProductDropdown
                  name="Prodotto"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.productId}
                />
              </FormField>
            </div>
          </div>


          <div class="columns">
            <div class="column">
              <FormField>
                <Input
                  name="Indirizzo" 
                  required={false} 
                  bind:value={$record.indirizzo}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <Input
                  name="CAP" 
                  required={false} 
                  bind:value={$record.cap}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <Input
                  name="Comune" 
                  required={false} 
                  bind:value={$record.comune}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <Input
                  name="Provincia" 
                  required={false} 
                  bind:value={$record.provincia}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <Input
                  name="Nazione" 
                  required={false} 
                  bind:value={$record.nazione}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <Input
                  name="Codice Fiscale" 
                  required={false} 
                  bind:value={$record.codiceFiscale}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <Input
                  name="Partita IVA" 
                  required={false} 
                  bind:value={$record.partitaIva}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <Textarea
                  name="Cod. ATECO" 
                  required={false} 
                  bind:value={$record.ateco}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <Textarea
                  name="Desc. ATECO" 
                  required={false} 
                  bind:value={$record.descrizioneAteco}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <DateInput
                  name="Data costituzione" 
                  required={false} 
                  bind:value={$record.dataCostituzione}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <Input
                  name="Stato" 
                  required={false} 
                  bind:value={$record.stato}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <NumberInput
                  name="N° dipendenti" 
                  required={false} 
                  bind:value={$record.numDipendenti}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <NumberInput
                  name="Capitale" 
                  required={false} 
                  bind:value={$record.capitale}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <Input
                  name="Contatto" 
                  required={false} 
                  bind:value={$record.contatto}
                />
              </FormField>
            </div>
          </div>          
 

          <div class="columns">
            <div class="column">
              <FormField>
                <Textarea
                  name="Note"
                  placeholder="note"
                  required={false}
                  bind:value={$record.notes}
                />
              </FormField>
            </div>
          </div>

          <CustomFields
            schemas={$customFieldsSchemas}
            bind:values={$record.customFields}
          />
        </FormLayout>
      </div>
      <div class="column is-3">
        <!--
        <div class="box">
          <h1 class="subtitle">Riepilogo</h1>
        </div>
      -->
        
        <ActivityListEditor
          entityId={$record.oid}
          entityType={'Lead'}
          activities={$activities}
          disabled={isNew}        
          on:save={addActivity} 
          on:edit={onEditActivity}
          on:complete={completeActivity}
        />    
        <MagazineSideEditor
          magId={$record.clfMagazineId}
          disabled={isNew}
          on:save={(ev) => onSaveMagazine(ev)}
        />
        <Secur8SideEditor
          clfSecur8Id={$record.clfSecur8Id}
          disabled={isNew}
          on:save={(ev) => onSaveSecur8(ev)}
        />
        
      </div>
    </div>
  {/if}
  </div>
